<script>
import {
  productDetailsVariantEmits,
  productDetailsVariantProps,
  useProductDetailsVariant
} from "@/components/organisms/product-sheet/product-details-variant/mixin";
import ButtonGroup from "@/components/molecules/button-group";
import Divider from "@/components/atoms/divider/index";
import FormRadio from "@/components/molecules/form-radio/index";
import Button from "@/components/atoms/button/index";

export default {
  components: {
    ButtonGroup,
    Divider,
    FormRadio,
    Button
  },
  name: "ProductVariantDetails",
  props: {
    ...productDetailsVariantProps()
  },
  emits: ["selectShopClicked", ...productDetailsVariantEmits()],
  setup(props, context) {
    const { selectedColor, selectedSize, sizesGuideLink, variantChanged } =
      useProductDetailsVariant(props, context);

    return {
      selectedColor,
      selectedSize,
      sizesGuideLink,
      variantChanged
    };
  }
};
</script>
<template>
  <div>
    <client-only>
      <div class="c-product-detail-variant__options">
        <p class="c-product-detail-variant__options-label">
          Couleurs
        </p>
        <div class="c-product-detail-variant__options-values">
          <FormRadio
            v-for="(availableColor, i) in availableColors"
            :key="`${availableColor}-${i}`"
            v-model="selectedColor"
            :value="availableColor"
            :checked="defaultColor === availableColor"
            :disabled="isNational"
            name="couleur"
            class="c-product-detail-variant__options-value"
            @change="variantChanged"
          >
            {{ availableColor }}
          </FormRadio>
        </div>
      </div>
      <div class="c-product-detail-variant__options">
        <p class="c-product-detail-variant__options-label">
          Tailles
        </p>
        <div class="c-product-detail-variant__options-values">
          <FormRadio
            v-for="(availableSize,i) in availableSizes"
            :key="`${availableSize.value}-${i}`"
            v-model="selectedSize"
            name="size"
            :checked="defaultSize === availableSize.value"
            :value="availableSize.value"
            :disabled="isNational ? true : !availableSize.available"
            class="c-product-detail-variant__options-value"
            button
            @change="variantChanged"
          >
            {{ availableSize.value }}
          </FormRadio>
          <Button
            :to="sizesGuideLink"
            link
            target="_blank"
          >
            <span class="u-color-text-light">Voir le guide des tailles</span>
          </Button>
        </div>
      </div>
      <ButtonGroup center>
        <Button @click="$emit('selectShopClicked')">
          <span
            v-if="isNational"
            class="u-color-primary u-text-underline u-font-14 u-mt-xs "
          > Trouver ma taille ou mon coloris</span>
          <span
            v-else
            class="u-color-primary u-text-underline u-font-14 u-mt-xs "
          > Trouver ma taille ou mon coloris dans un autre magasin</span>
        </Button>
      </ButtonGroup>
      <Divider dotted />
    </client-only>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/product-details-variant.scss";
</style>
